<template>
  <div class="main wrap">
<!--    轮播图-->
    <div class="col-11 imgWrap wrap">
      <div id="carouselExampleIndicators" class="carousel carousel-dark slide carousel-fade" data-bs-ride="carousel">
      <ol class="carousel-indicators">
        <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" class="active"></li>
        <li data-bs-target="#carouselExampleIndicators" data-bs-slide-to="1"></li>
      </ol>
      <div class="carousel-inner">
        <div class="carousel-item active" data-bs-interval="2000">
          <img src="../../assets/img/banner1.png" class="d-block w-100" alt="...">
        </div>
        <div class="carousel-item" data-bs-interval="2000">
          <img src="../../assets/img/banner2.png" class="d-block w-100" alt="...">
        </div>
      </div>
      <a class="carousel-control-prev" href="#carouselExampleIndicators" role="button" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true" ></span>
        <span class="visually-hidden">Previous</span>
      </a>
      <a class="carousel-control-next" href="#carouselExampleIndicators" role="button" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true" ></span>
        <span class="visually-hidden">Next</span>
      </a>
    </div>
    </div>
<!--    视频和新闻-->
    <div class="wrap">
      <div class="container-fluid videoPart">
        <div class="row justify-content-center">
          <div class="col-11 col-md-9">
            <video controls preload="auto" autoplay>
              <source src="../../assets/cxsp.mp4"
                      type="video/mp4" >mp4
              Sorry, your browser doesn't support embedded videos.
            </video>
          </div>
        </div>

        <div class="row col-11 col-md-9 newsWrap  justify-content-between">
          <div class="col-6 newsLeft" @click="$router.push('/develop')">
            <img class="cxsp" src="../../assets/img/cxsp.jpg" alt="">
            <div class="newsContent sy">企业发展历程</div>
          </div>
          <div class="col-6 newsRight" @click="$router.push('/boss')">
            <img class="boss" src="../../assets/img/boss.jpg" alt="">
            <div class="newsContent sy">董事长致辞</div>
          </div>
          </div>
        </div>
      </div>
      <!--        news-->
      <div class="news">
        <div class="sy newsPaper">新闻速报</div>
        <div class="jc500 newsStatus col-11 col-md-9 titleSpan">
          最新动态
        </div>
        <div class="jc500 col-11 col-md-9  newsList" >
          <div v-for="(news,index) in newsLists" :key="index" @click=toWechat(news.index)>
            <div  class="col-11 newsSpan">
              <span class="fonts ">
                <svg class="bi bi-chevron-right" width="32" height="32" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M6.646 3.646a.5.5 0 01.708 0l6 6a.5.5 0 010 .708l-6 6a.5.5 0 01-.708-.708L12.293 10 6.646 4.354a.5.5 0 010-.708z"/></svg>
              </span>
                <span class="dates">{{news.Time}}</span>
                <span class="newss d-none d-md-flex">News</span>
                <span class="titles">{{news.context}}</span>
            </div>
          </div>
        </div>

        <div class="jc500 col-3 col-md-2 findList" @click="$router.push('/newslist')">见列表</div>
      </div>
    </div>

</template>

<script>
export default {
  name: "index",
  data(){
    return{
      newsLists:[

        {Year: "2025年",Time: "06月23日",context: "春雪食品集团股份有限公司“择势而进，携手共赢”2025新品发布会圆满举办！",index: "https://mp.weixin.qq.com/s/-RjmSLq4nhS27wcEsoJmtg"},
        {Year: "2025年",Time: "06月23日",context: "春雪食品集团2025年新品重磅发布，引领安心美味新主张！",index: "https://mp.weixin.qq.com/s/ZcH9jNIEsYaLf48uGAAaKA"},
        {Year: "2025年",Time: "03月29日",context: "春雪食品集团数智化进程再升级，AI技术赋能推动公司高质量发展！",index: "https://mp.weixin.qq.com/s/sCT-kpNoCaCfju7EufQTGQ"},

        // {Time:"2024年12月10日",context:"春雪食品集团当选山东省肉类协会轮值会长,积极助力行业发展",index:"https://mp.weixin.qq.com/s/9AGlpYlHdBQv1Pp9evdERg"}
      ]
    }
  },
  methods:{
    toWechat(index){
      window.open(index);
    }
  }
}
</script>

<style scoped lang="less">

video{
  width: 100%;
  height: auto;
}
.main{
  position: relative;
  z-index: 1;
  overflow:hidden;
}
.carousel-control-prev{
  justify-content: left;
}
.carousel-control-next{
  justify-content: right;
}
.wrap{
  //background: url("../../assets/img/flower.jpg");
}
.newsWrap{
  margin:0 auto;
  .newsContent{
    text-align: center;
    margin-top: 1rem;
    font-size: .9rem;
    font-weight: bold;
    img{
      overflow: hidden;
    }
  }
}
.videoPart {
  img{
    width: 100%;
    height: auto;
    transition: all 0.2s;
    overflow: hidden;
  }
  .row{
    margin-top: 5rem;
  }

}
.news{
  margin:3rem auto 5rem;
  height: 34rem;
  display: block;
  background-color: #ffeecc;
  overflow: hidden;
  > div{
    text-align: center;
  }
  .newsPaper{
    font-size: 250%;
    margin-top: 4rem;
    font-weight: bold;
    letter-spacing: .3rem;
  }
  .newsStatus{
    display: block;
    background-color: #fff;
    line-height: 3rem;
    font-weight: 600 !important;
    font-size: 1.3rem;
    margin:1rem auto ;
  }
  .newsList{
    background-color: #fff;
    margin:0 auto;
    font-size: .9rem;
    font-weight: 500;
    :hover{
      background-color: #ffd480;
    }
    .newsSpan {
      text-align: left;
      height: 4rem;
      vertical-align: middle;
      margin: 0 auto;
      display: flex;
      align-items: center;

      .fonts{
        display: flex;
        width: 25px;
        height: 25px;
        background-color: #ffc34d;
        border-radius: 50%;
        justify-content: center;
        align-items: center;
        font-weight: bold;

      }
      .dates{
        margin: 0 .5rem 0 .5rem;
        white-space: nowrap;
      }
      .newss{
        background-color: #ffc34d;
        margin: 0 1rem;
        display: flex;
        width: 4rem;
        justify-content: center;
      }
    }
  }
  .findList{
    margin-top: 2rem;
    background-color: #565e64;
    color: #ffffff;
    display: block;
    line-height: 3rem;
    margin-left: 41.67% ;
    border-radius: 5px;
    font-size: 1rem;
    &:hover{
      background-color: #ffc34d;
      color: #000;
    }
  }

}
.boss:hover,.cxsp:hover{
  transform: scale(1.05);
  box-shadow: 6px 6px 20px rgba(0,0,0,.3);
}
@media (max-width:1200px) {
  .videoPart .row{
    margin-top: 3rem;
  }
  .news{
    margin:5rem auto 5rem;
  }
}
@media (max-width:768px) {
  .videoPart .row{
    margin-top: 1rem;
  }
  .news{
    margin:3rem auto 2rem;
    height: 30rem;
  }

}
.newsLeft{
  padding-left: 0;

}
.newsRight{
  padding-right: 0;

}
</style>



// WEBPACK FOOTER //
// src/pages/main/index.vue